// extracted by mini-css-extract-plugin
export var content = "_pz-1";
export var fullScreen = "_pz-0";